import { CAREERS_URL } from "../siteLinks";
import { ContactDialog } from "./ContactDialog";
import { Logo } from "./Logo";

/**
 * One bar at every width. Home is not listed — the mark is the way back, and a
 * two-item bar is what makes the labels legible at this size.
 */
export function SiteHeader() {
  return (
    <header className="site-header">
      <Logo />
      <nav className="site-nav" aria-label="Primary">
        <a href={CAREERS_URL} rel="noreferrer" target="_blank">
          Careers
        </a>
        <ContactDialog />
      </nav>
    </header>
  );
}
